"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHtmlCanvasElement = void 0;
exports.isHtmlCanvasElement = function (canvas) {
    return "getContext" in canvas;
};
//# sourceMappingURL=isHtmlCanvasElement.js.map